import styled from 'styled-components';

const StyledFlagEmoji = styled.img`
  box-sizing: border-box;
`;

export default StyledFlagEmoji;
